module.exports = __webpack_public_path__ + "img/symbol_1.9019e95e.png";